import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { useCountdown } from '@swf/sports/hooks/useCountdown';

import {
  TXTWCL_Next_Race_Starting_Now,
  TXTWCL_Next_Race_Starting_in_N0h_1,
  TXTWCL_Next_Race_Starting_in_N0h_N1m,
  TXTWCL_Next_Race_Starting_in_N0m,
  TXTWCL_Next_Race_Starting_in_N2d
} from './Countdown.messages.json';

export interface Props {
  countdownDate: string;
}

const getCountdown = ({
  days,
  hours,
  minutes
}: {
  days: number;
  hours: number;
  minutes: number;
}) => {
  if (days > 0) {
    return <Translation {...TXTWCL_Next_Race_Starting_in_N2d} values={{ 0: days }} />;
  } else if (hours > 0) {
    return minutes > 0 ? (
      <Translation {...TXTWCL_Next_Race_Starting_in_N0h_N1m} values={{ 0: hours, 1: minutes }} />
    ) : (
      <Translation {...TXTWCL_Next_Race_Starting_in_N0h_1} values={{ 0: hours }} />
    );
  } else if (minutes > 0) {
    return <Translation {...TXTWCL_Next_Race_Starting_in_N0m} values={{ 0: minutes }} />;
  } else {
    return <Translation {...TXTWCL_Next_Race_Starting_Now} />;
  }
};

export const Countdown: React.FC<Props> = ({ countdownDate }) => (
  <>{getCountdown(useCountdown(countdownDate))}</>
);
